//@ts-strict-ignore

export const normalizeUpperCase = (_dataid: any, value: string, _previousValues: string) => {
  return value ? value.toUpperCase() : value;
};

// Returns the first float value found in the data.
// Is currently written to handle a grid entry specifically.
export const normalizeNumeric = (_dataid, value, _previousValues) => {
  const parsedNumerics: string = value.updated[value.cellKey].match(/[+-]?\d+(\.\d+)?/g);
  if (parsedNumerics) {
    value.updated[value.cellKey] = parseFloat(parsedNumerics[0]);
  } else {
    value.updated[value.cellKey] = 0;
  }
  return value;
};
